<div class="container">
    <button class="btn-close" (click)="close()"> &times;</button>
    <img src={{image}} alt="imagen de la camara">
</div>